export {
  Label,
  //
  Root,
  //
  useLabelContext,
} from './Label';
export type { LabelProps } from './Label';
